import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import AdMedia from './AdMedia';
import AdLink from './AdLink';

class AdCore extends PureComponent {
    static propTypes = {
        content: PropTypes.object.isRequired,
        methods: PropTypes.object.isRequired,
    };

    render() {
        const { content, methods } = this.props;
        const { playerWidth, playerHeight, adList, playIndex, canPlaySounds, clickPlaySounds } = content;

        return (
            <div className={styles.wrap}>
                {adList.map((item, index) => {
                    const { materialType, clickUrl } = item;

                    return (
                        <div
                            className={styles.item}
                            style={{ display: index === playIndex ? 'block' : 'none' }}
                            key={index}>
                            <AdMedia
                                content={{
                                    data: item,
                                    playerWidth,
                                    playerHeight,
                                    playIndex,
                                    index,
                                    canPlaySounds,
                                    clickPlaySounds,
                                }}
                                methods={methods}
                            />
                            {materialType !== 'iframe' && clickUrl ? (
                                <AdLink content={{ clickUrl, index }} methods={methods} />
                            ) : null}
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default AdCore;
